export const FACEBOOK_PIXEL_ID = "774783043158501";
